// @flow
import axios from 'lib/defaultClient';
import queryString from 'query-string';

export type WriteProductPayload = {
  title: string,
  body: string,
  is_temp: boolean,
  tags: Array<string>,
  badges: Array<string>,
  categories: Array<string>,
  thumbnail: ?string,
  url_slug?: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const writeProduct = (payload: WriteProductPayload) => axios.post('/products', payload);

export type UpdateProductPayload = {
  id: string,
  title: string,
  body: string,
  tags: Array<string>,
  badges: Array<string>,
  categories: Array<string>,
  url_slug?: ?string,
  thumbnail?: string,
  is_temp: boolean,
  thumbnail: ?string,
  is_private: boolean,
  series_id: ?string,
};

export const updateProduct = ({ id, ...payload }: UpdateProductPayload) =>
  axios.patch(`/products/${id}`, payload);

export type ReadProductPayload = {
  username: string,
  urlSlug: string,
  type?: string,
};

export const readProduct = ({ username, urlSlug, type }: ReadProductPayload) =>
  axios.get(`/products/@${username}/${urlSlug}`, {
    params: {
      type,
    },
  });

export type UploadImagePayload = {
  file: any,
  productId: string,
  onUploadProgress(): void,
};

export const uploadImage = ({ file, productId, onUploadProgress }: UploadImagePayload) => {
  const data = new FormData();
  data.append('product_id', productId);
  data.append('image', file);
  return axios.post('/files/upload/product', data, {
    onUploadProgress,
  });
};

export type TempSavePayload = {
  title: string,
  body: string,
  productId: string,
};

export const tempSave = ({ productId, title, body }: TempSavePayload) =>
  axios.post(`/products/${productId}/saves`, { title, body });

export type CreateUploadUrlPayload = { productId: string, filename: string };
export const createUploadUrl = ({ productId, filename }: CreateUploadUrlPayload) => {
  return axios.post('/files/create-url/product-image', { product_id: productId, filename });
};

/* LISTING RELATED... */
export const getPublicProducts = (cursor: ?string, category: ?string, sort: ?string) => {
  return axios.get('/products/public', {
    params: {
      cursor,
      category,
      sort,
    },
  });
};

export const getTrendingProducts = (offset: ?number) => {
  const query = offset ? `?offset=${offset}` : '';
  return axios.get(`/products/trending${query}`);
};

export type GetUserProductsPayload = {
  username: string,
  tag?: string,
  badge?: string,
  cursor?: string,
};

export const getUserProducts = ({ username, cursor, tag, badge }: GetUserProductsPayload) => {
  const query = queryString.stringify({
    cursor,
    tag,
    badge,
  });
  return axios.get(`/products/@${username}?${query}`);
};

export type GetPublicProductsByCategoryPayload = {
  category: string,
  cursor?: string,
  sort?: string,
  supplier?: string,
};

export const getPublicProductsByCategory = (payload: GetPublicProductsByCategoryPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/products/public?${query}`);
};

export type GetPublicProductsByTagPayload = {
  tag: string,
  cursor?: string,
};

export const getPublicProductsByTag = (payload: GetPublicProductsByTagPayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/products/public?${query}`);
};

export type GetPublicProductsByBadgePayload = {
  badge: string,
  cursor?: string,
};

export const getPublicProductsByBadge = (payload: GetPublicProductsByBadgePayload) => {
  const query = queryString.stringify(payload);
  return axios.get(`/products/public?${query}`);
};

export type GetTempProductsPayload = {
  username: string,
  cursor?: string,
};

export const getTempProducts = ({ username, cursor }: GetTempProductsPayload) => {
  const query = queryString.stringify({
    is_temp: true,
    cursor,
  });
  return axios.get(`/products/@${username}?${query}`);
};

export const deleteProduct = (productId: string) => {
  return axios.delete(`/products/${productId}`);
};

export const getProductById = (productId: string) => {
  return axios.get(`/products/${productId}`);
};

export const getProductSequences = (productId: string) => {
  return axios.get(`/products/sequences?product_id=${productId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/products/index.js